var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 21.0001C17.2 20.8001 17.6 20.8001 17.8 21.0001L23.4 23.4001C24 24.4001 24.4 25.4001 25 26.2001V41.2001L32.6 38.8001L31.2 32.0001C31.6 31.4001 32.2 30.6001 32.6 29.6001L34.2 39.0001L41.4 41.2001L36.2 25.4001L35.2 25.0001C35.8 24.6001 36 24.0001 36.4 23.6001L37.6 24.0001C37.8 24.2001 38 24.4001 38 24.6001L44 42.4001C44.2 42.8001 44 43.0001 43.8 43.4001C43.6 43.6001 43.4 43.6001 43.2 43.6001H43L33.8 40.8001L24.6 43.6001C24.4 43.6001 24.2 43.6001 24 43.6001L14.8 40.8001L5.6 43.6001C5.2 43.6001 5 43.6001 4.6 43.4001C4 43.2001 4 42.8001 4 42.6001L10 24.8001C10 24.4001 10.2 24.2001 10.4 24.0001L17 21.0001ZM13.6 39.2001L6.4 41.4001L11.6 25.6001L16.2 23.6001L13.6 39.2001ZM23 41.6001L15.4 39.2001L18 23.2001L22.8 25.4001V41.6001H23Z",
    fill: "#007AC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4004 13.8C37.4004 18.2 30.0004 29.4 30.0004 29.4C30.0004 29.4 22.4004 18 22.4004 13.8C22.4004 9.6 25.8004 6 29.8004 6C33.8004 6 37.4004 9.4 37.4004 13.8ZM33.2004 13.4C33.2004 11.6 31.8004 10 29.8004 10C28.0004 10 26.4004 11.4 26.4004 13.4C26.4004 15.2 27.8004 16.8 29.8004 16.8C31.6004 16.8 33.2004 15.4 33.2004 13.4Z",
    fill: "#007AC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.848a34f41e7639a1d25a5b05f7427154.svg";
export { ForwardRef as ReactComponent };